import React, { useEffect } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { User } from '../../../global';
import axiosHelper from '../../../helpers/axiosHelper';
import FormField from '../../Forms/FormField';
import { useBanner } from '../../../context/BannerContext';
interface Props {
  user: User;
  onChange: (user: User) => void;
}

const NewsletterNotifications: React.FC<Props> = ({ user, onChange }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<Partial<User>>({
    defaultValues: user, // Pre-fill form with the user's data
  });
  const { createAndAddBannerMessage } = useBanner();

  useEffect(() => {
    reset(user);
  }, [user, reset]);

  const onSubmit: SubmitHandler<Partial<User>> = async (data) => {
    const userdata = await axiosHelper.updateDSLUser(data);
    if (userdata) {
      createAndAddBannerMessage('Profile updated successfully!', 'success', 'profile-update-success');
      onChange(userdata);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="px-5 mt-7">
        <FormField name="receiveNewsletter" label="Newsletter">
            <input type="checkbox" className="" {...register('receiveNewsletter')} tabIndex={0}/>
            <label>Receive Desall newsletter</label>
        </FormField>

        <FormField name="hasPrivateMessagesNotification" label="General">
            <input type="checkbox" className="" {...register('hasPrivateMessagesNotification')} tabIndex={0}/>
            <label>Send and receive private messages</label>
        </FormField>

        <FormField name="hasBadgeNotification">
            <input type="checkbox" className="" {...register('hasBadgeNotification')} tabIndex={0}/>
            <label>Badge updates</label>
        </FormField>

        <FormField name="hasNewContestOnDesallNotification" label="Contest">
            <input type="checkbox" className="" {...register('hasNewContestOnDesallNotification')} tabIndex={0}/>
            <label>New contest on desall.com</label>
        </FormField>

        <FormField name="hasContestStatusChangesNotification">
            <input type="checkbox" className="" {...register('hasContestStatusChangesNotification')} tabIndex={0}/>
            <label>My favourite contests brief revisions and contests status changes (upload phase, vote phase, winner announcement)</label>
        </FormField>

        <FormField name="hasNewCommentForMyDesignNotification" label="Design">
            <input type="checkbox" className="" {...register('hasNewCommentForMyDesignNotification')} tabIndex={0}/>
            <label>New comments on my designs</label>
        </FormField>

        <FormField name="hasRepliesOnMyCommentsNotification">
            <input type="checkbox" className="" {...register('hasRepliesOnMyCommentsNotification')} tabIndex={0}/>
            <label>Replies on my comments</label>
        </FormField>

        <FormField name="hasSomebodyFavoriteMyDesignNotification">
            <input type="checkbox" className="" {...register('hasSomebodyFavoriteMyDesignNotification')} tabIndex={0}/>
            <label>Somebody favourite my designs</label>
        </FormField>

        <FormField name="hasMeAsFavouriteNotification" label="Favourite">
            <input type="checkbox" className="" {...register('hasMeAsFavouriteNotification')} tabIndex={0}/>
            <label>Somebody saves me as favourite</label>
        </FormField>

        <FormField name="hasNewDesignFromFavoriteNotification">
            <input type="checkbox" className="" {...register('hasNewDesignFromFavoriteNotification')} tabIndex={0}/>
            <label>My favourite designers upload a new design</label>
        </FormField>

        <FormField name="hasNewEntryForFavoriteNotification">
            <input type="checkbox" className="" {...register('hasNewEntryForFavoriteNotification')} tabIndex={0}/>
            <label>
              My favourite contests receive a new entry
              (during the ending phase you might receive a lot of notifications)
            </label>
        </FormField>

        <div className="row  d-flex justify-content-center align-items-center mb-7">
          <div className="row justify-content-center ">
            <button className="btn-success rounded col-12 col-md-4 button">update preferences</button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default NewsletterNotifications;
